import api from "./apiSmartLogistics.js";

export default {
  GetViewUsersOperations() {
    return api.get("ViewUsersOperationsUsersOperations/GetViewUsersOperations");
  },

  GetViewUserOperation(Id) {
    return api.get(
      "ViewUsersOperationsUsersOperations/GetViewUserOperation/" + Id
    );
  },

  InsertViewUsersOperations(usersOperations) {
    return api.post(
      "ViewUsersOperationsUsersOperations/InsertViewUsersOperations",
      usersOperations
    );
  },

  UpdateViewUsersOperations(usersOperations) {
    return api.put(
      "ViewUsersOperationsUsersOperations/UpdateViewUsersOperations",
      usersOperations
    );
  },

  DeleteViewUsersOperations(Id) {
    return api.delete(
      "ViewUsersOperationsUsersOperations/DeleteViewUsersOperations/" + Id
    );
  }
};
